<template>

    <section id="new_ref_fifth_step" class="flex">

        <titlePage>
            <template slot="titleBody">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 ">{{ currentPosition.name }}</h1>
                    <h2 class="associated_ref_name">{{ $t('modules.positions.formStep5.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
                </div>
            </template>
        </titlePage>

        <div class="hero container ">
            <div class="hero-body">
                <div id="position_use_custom_email" v-if="currentPosition">

                    <div class="email_inputs_container">

                        <h2 class="title is-size-1 has-text-weight-bold stepTitle has-text-centered">
                            {{ $t('modules.positions.formStep5.title') }}
                        </h2>

                        <div class="custom_email_mini_container">
                            <notifText class="notice_custom_email">
                                <span v-html="$t('modules.positions.formStep5.notice')"></span>
                            </notifText>
                            <br>
                            <br>
                            <SwitchInput switchId="email_custom_enabled"
                                class="custom_email_switch"
                                :switchLabel="$t('modules.positions.formStep5.radioLabel')"
                                :falseValue="false"
                                :trueValue="true"
                                :value="currentPosition.is_campaign"
                                @change="handleSwitch" />

                            <transition name="fade">

                                <div class="date_picker_container" v-if="currentPosition.is_campaign">
                                    <Datepicker
                                        wrapperClass="md-input"
                                        inputClass="has-value"
                                        format="dd/MM/yyyy"
                                        id="campaign_date"
                                        :bootstrap-styling="true"
                                        :language="datePickerLanguage"
                                        :value="currentPosition.campaign_end_date"
                                        @input="handleDate">


                                        <label for="campaign_date" slot="afterDateInput">
                                            {{ $t('modules.positions.index.positionsList.campaignEndDate') }}
                                        </label>

                                    </Datepicker>

                                    <div class="campaign_link_label" v-if="!isNew">
                                        {{ $t('modules.positions.index.positionsList.campaignLink') }}
                                    </div>

                                    <div class="campaign_link no_margin" v-if="!isNew">
                                        {{currentPosition.campaign_link}}
                                    </div>

                                </div>
                            </transition>
                        </div>


                    </div>


                    <div class="next_step_button has-text-centered"  v-if="isNew">
                        <btn-circle-icon
                            class="large is-cursor"
                            icon="icon-arrow-right"
                            @click.native="nextStep" />
                    </div>

                </div>
            </div>
        </div>


    </section>

</template>

<script>
import titlePage from "@/components/layouts/titlePage"
import Datepicker from 'vuejs-datepicker';
import {fr, en} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'formEvalStep5',
    props: ["isNew"],
    components: {
        titlePage,
        Datepicker
    },
    data(){
        return {

        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        associatedRef(){
            return this.$store.state.PositionStore.associatedRef
        },
        datePickerLanguage(){
            if (this.$i18n.locale == 'fr'){
                return fr
            }else if(this.$i18n.locale == 'en'){
                return en
            }
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        nextStep(){
            this.$store.commit('PositionStore/changeCurrentStep', { index: 5 })
        },
        handleSwitch(id, value){
            this.$store.commit('PositionStore/updatePositionData', {is_campaign: value} )
        },
        handleDate(date){
            this.$store.commit('PositionStore/updatePositionData', {campaign_end_date: date} )

        }
    }
}

</script>

<style lang="scss" >
#new_ref_fifth_step{
    background: $white;

    display: flex;
    flex-direction: column;
    .subsection_container{
        background: $white;
        .hero-body{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 100px;
            .stepTitle{
                max-width: 500px;
                text-align: center;
            }
        }
    }
    .bottom_btn_container{
        display: flex;
        justify-content: space-around;
    }
    .evals_actions{
        .btn_underline{
            width: 240px;
        }
    }
    .email_notice{
        margin-top: 20px;
        max-width: 500px;
        margin: 20px auto 0;
        color: $grey;
    }
}

.date_picker_container{
    .vdp-datepicker__calendar{
        width: 100%;
        bottom: 2px;
        .cell{
            &:hover{
                border-color: $info!important;
            }
            &.selected {
                background: $info;
                color: white;
                font-weight: 500;
            }
        }
    }
}
.campaign_link{
    word-break: break-all;
    &.no_margin{
        margin-top: 0;
    }
}

.campaign_link_label{
    margin-top: 30px;
    font-weight: 600;
    color: #7a7a7a;
    text-transform: uppercase;
    font-size: 11px;
}
</style>